"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCampaignByUserId = exports.campaignsWithCustomProfiles = exports.campaigns = exports.CampaignTypeEnum = void 0;
var CampaignTypeEnum;
(function (CampaignTypeEnum) {
    CampaignTypeEnum["US_TWO"] = "US_TWO";
    CampaignTypeEnum["INTREPID_REFOREST"] = "INTREPID_REFOREST";
    CampaignTypeEnum["FOREST_OF_LOVE"] = "FOREST_OF_LOVE";
    CampaignTypeEnum["LAPLAND_UK"] = "LAPLAND_UK";
    CampaignTypeEnum["AXA_IRELAND"] = "AXA_IRELAND";
    CampaignTypeEnum["PEPPA_PIG"] = "PEPPA_PIG";
    CampaignTypeEnum["WEAREALBERT"] = "WEAREALBERT";
})(CampaignTypeEnum = exports.CampaignTypeEnum || (exports.CampaignTypeEnum = {}));
exports.campaigns = {
    intrepid: {
        id: 'INTREPID_REFOREST',
        username: 'intrepid-kijabe',
        userId: '5de14859a48249001750a1af',
        type: CampaignTypeEnum.INTREPID_REFOREST,
    },
    lapland: {
        id: 'LAPLAND_UK',
        username: 'plantree',
        userId: '5ddfcc0260bcf6001843d174',
        type: CampaignTypeEnum.LAPLAND_UK,
    },
    forestOfLove: {
        id: 'FOREST_OF_LOVE',
        username: 'theforestoflove',
        userId: '5e33083a8b619200173e1043',
        type: CampaignTypeEnum.FOREST_OF_LOVE,
    },
    usTwo: {
        id: 'US_TWO',
        username: 'albasforest',
        userId: '5fcfb9fd8d5804001d868193',
        type: CampaignTypeEnum.US_TWO,
    },
    axaIreland: {
        id: 'AXA_IRELAND',
        username: 'axa-ireland',
        userId: '613a4bf3d0ea67f1a8055d94',
        type: CampaignTypeEnum.AXA_IRELAND,
    },
    peppaPig: {
        id: 'PEPPA_PIG',
        username: 'peppasforest',
        userId: '60fecd5f23edfb2360a24965',
        type: CampaignTypeEnum.PEPPA_PIG,
    },
    wearealbert: {
        id: 'WEAREALBERT',
        username: 'wearealbert',
        userId: '6294a7122dd4b8cdcdde973e',
        type: CampaignTypeEnum.WEAREALBERT,
    },
};
exports.campaignsWithCustomProfiles = {
    usTwo: exports.campaigns.usTwo,
    forestOfLove: exports.campaigns.forestOfLove,
    axaIreland: exports.campaigns.axaIreland,
    peppaPig: exports.campaigns.peppaPig,
    wearealbert: exports.campaigns.wearealbert,
};
const getCampaignByUserId = (userId) => {
    const campaign = Object.values(exports.campaignsWithCustomProfiles).find((campaign) => campaign.userId === userId);
    return campaign;
};
exports.getCampaignByUserId = getCampaignByUserId;
//# sourceMappingURL=data:application/json;base64,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